export default __webpack_public_path__ + "static/media/img-about-full-circle-economy-mobile-min.9ed26800.png";